import inherits from 'inherits';

import BaseRenderer from 'diagram-js/lib/draw/BaseRenderer';

import {
  componentsToPath,
  createLine
} from 'diagram-js/lib/util/RenderUtil';

import {
  append as svgAppend,
  attr as svgAttr,
  create as svgCreate
} from 'tiny-svg';

var COLOR_GREEN = '#346cad',
    COLOR_WHITE = "#346cad",
    COLOR_OFF_WHITE = "#346cad";

/**
 * A renderer that knows how to render custom elements.
 */
export default function CustomRenderer(eventBus, styles) {

  BaseRenderer.call(this, eventBus, 2000);

  var computeStyle = styles.computeStyle;

  this.drawTriangle = function(p, side) {
    var halfSide = side / 2,
        points,
        attrs;

    points = [side, 0, side, side, 0, side ];

    attrs = computeStyle(attrs, {
      stroke: COLOR_WHITE,
      strokeWidth: 2,
      fill: COLOR_GREEN
    });

    var polygon = svgCreate('polygon');

    svgAttr(polygon, {
      points: points
    });

    svgAttr(polygon, attrs);

    //svgAppend(p, polygon);

   /* return polygon;*/

    /*var smgImg = svgCreate('image');
    svgAttr(smgImg, {
      src: "play-sign_Green.svg", 
      alt: "triangle with all three sides equal",
      height: "87",
      width: "100"
    });*/

    var svgimg = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    svgimg.setAttributeNS(null, 'height', '100');
    svgimg.setAttributeNS(null, 'width', '100');
    svgimg.setAttributeNS('http://www.w3.org/1999/xlink', 'href', 'play-sign_Green.svg');
    //svgAppend(p, svgimg);
    p.append(svgimg);
    return polygon;
  };

  this.getTrianglePath = function(element) {
    var x = element.x,
        y = element.y,
        width = element.width,
        height = element.height;

    var trianglePath = [
      ['M', x + width / 2, y],
      ['l', width / 2, height],
      ['l', -width, 0 ],
      ['z']
    ];

    return componentsToPath(trianglePath);
  };

  this.customModel = function (p, modelImg, modelHeight, modelWidth, modelName) {
    var circle = svgCreate('circle');
    var svgNS = "http://www.w3.org/2000/svg";
    var svgimg = document.createElementNS(svgNS, 'image');
    var modalImagePath = 'assets/bpmn/defaultModel.svg';
    if (modelImg && modelImg !== "null") {
      modalImagePath = "data:image/svg+xml;base64," + modelImg;// 'assets/bpmn/defaultModel.svg';
    } else {
      modalImagePath = 'assets/bpmn/defaultModel.svg';
    }
    svgimg.setAttributeNS(null, 'height', modelHeight);
    svgimg.setAttributeNS(null, 'width', modelWidth);

    svgimg.setAttributeNS('http://www.w3.org/1999/xlink', 'href', modalImagePath);
    svgAppend(p, svgimg);
    
    var newText = document.createElementNS(svgNS, "text");
    newText.setAttributeNS(null, "x", modelWidth/2);
    newText.setAttributeNS(null, "y", modelHeight+12);
    newText.setAttributeNS(null, "font-size", "13");
    newText.setAttributeNS(null, "fill", "#346cad");
    newText.setAttributeNS(null, "dominant-baseline", "middle");
    newText.setAttributeNS(null, "text-anchor", "middle");
    var textNode = document.createTextNode(modelName);
    newText.appendChild(textNode);
    svgAppend(p, newText);
    return circle;
  };

  this.getModelPath = function (shape) {
    //shape.height = 100;
    var cx = shape.x + shape.width / 2,
        cy = shape.y + shape.height / 2,
        radius = shape.width / 2;

    var circlePath = [
      ['M', cx, cy],
      ['m', 0, -radius],
      ['a', radius, radius, 0, 1, 1, 0, 2 * radius],
      ['a', radius, radius, 0, 1, 1, 0, -2 * radius],
      ['z']
    ];

    return componentsToPath(circlePath);
  };

  var draw = function (type, opts) {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", type);
    for (var k in opts) {
      svg.setAttribute(k, opts[k]);
    }
    return svg;
  };

  this.drawCustomConnection = function (p, element) {
    var marker = draw("marker", {
      "id": "endpoint",
      "viewBox": "-50 0 50 50",
      "refX": 0,
      "refY": 25,
      "markerUnits": "strokeWidth",
      "markerWidth": 5,
      "markerHeight": 5,
      "orient": "auto",
      "fill": COLOR_OFF_WHITE
    });
    var marker_path = draw("path", {
      "d": "M -50 0 L 0 25 L -50 50 z"
    });

    svgAppend(p, marker);
    marker.appendChild(marker_path);

    var attrs = computeStyle(attrs, {
      stroke: COLOR_OFF_WHITE,
      strokeWidth: 2,
      strokeDasharray: 5,
      markerEnd: "url(#endpoint)"
    });

    return svgAppend(p, createLine(element.waypoints, attrs));
  };

  this.getCustomConnectionPath = function(connection) {
    var waypoints = connection.waypoints.map(function(p) {
      return p.original || p;
    });

    var connectionPath = [
      ['M', waypoints[0].x, waypoints[0].y]
    ];

    waypoints.forEach(function(waypoint, index) {
      if (index !== 0) {
        connectionPath.push(['L', waypoint.x, waypoint.y]);
      }
    });

    return componentsToPath(connectionPath);
  };
}

inherits(CustomRenderer, BaseRenderer);

CustomRenderer.$inject = [ 'eventBus', 'styles' ];


CustomRenderer.prototype.canRender = function(element) {
  return /^bpmn:/.test(element.type);
};

CustomRenderer.prototype.drawShape = function(p, element) {
  var type = element.type;
  var modelType = element.modelType;

  if (modelType === 'custom-fcc') {
    return this.drawTriangle(p, element.width);
  }

  if (modelType === 'custom') {
    element.businessObject.$attrs['modelType'] = 'custom';
    element.businessObject.$attrs['modelImg'] = element.modelImg;
    element.businessObject.$attrs['modelName'] = element.modelName;
    element.businessObject.$attrs['modelId'] = element.modelId;
    element.businessObject.$attrs['modelUniqueId'] = element.modelUniqueId;
    return this.customModel(p, element.modelImg, element.height, element.width, element.modelUniqueId);
  }

  if (element.businessObject.$attrs.modelType === 'custom') {
    return this.customModel(p, element.businessObject.$attrs.modelImg, element.height, element.width, element.businessObject.$attrs.modelUniqueId);
  }
};

CustomRenderer.prototype.getShapePath = function(shape) {
  var type = shape.type;
  var modelType = shape.modelType;

  if (modelType === 'custom-fcc') {
    return this.getTrianglePath(shape);
  }

  if (modelType === 'custom') {
    return this.getModelPath(shape);
  }
};

CustomRenderer.prototype.drawConnection = function(p, element) {

  var type = element.type;

  //if (type === 'custom:connection') {
    return this.drawCustomConnection(p, element);
  //}
};


CustomRenderer.prototype.getConnectionPath = function(connection) {

  var type = connection.type;

  if (type === 'custom:connection') {
    return this.getCustomConnectionPath(connection);
  }
};